class Maps {
    constructor() {
        this.dualRecords = {
            "tier-q1": {
                "tier-q1a1": {
                    db: { quizId: 1, optionId: 1 }
                },
                "tier-q1a2": {
                    db: { quizId: 1, optionId: 2 }
                },
                "tier-q1a3": {
                    db: { quizId: 1, optionId: 3 }
                }
            },
            "tier-q2": {
                "tier-q2a1": {
                    db: { quizId: 2, optionId: 4 }
                },
                "tier-q2a2": {
                    db: { quizId: 2, optionId: 5 }
                },
                "tier-q2a3": {
                    db: { quizId: 2, optionId: 6 }
                }
            },
            "tier-q3": {
                "tier-q3a1": {
                    db: { quizId: 3, optionId: 7 }
                },
                "tier-q3a2": {
                    db: { quizId: 3, optionId: 8 }
                },
                "tier-q3a3": {
                    db: { quizId: 3, optionId: 9 }
                }
            },
            "prod-q1": {
                "prod-q1a1": {
                    db: { quizId: 4, optionId: 10 }
                },
                "prod-q1a2": {
                    db: { quizId: 4, optionId: 11 }
                },
                "prod-q1a3": {
                    db: { quizId: 4, optionId: 12 }
                },
                "prod-q1a4": {
                    db: { quizId: 4, optionId: 13 }
                },
                "prod-q1a5": {
                    db: { quizId: 4, optionId: 14 }
                },
                "prod-q1a6": {
                    db: { quizId: 4, optionId: 15 }
                }
            },
            "prod-q2": {
                "prod-q2a1": {
                    db: { quizId: 5, optionId: 16 }
                },
                "prod-q2a2": {
                    db: { quizId: 5, optionId: 17 }
                },
                "prod-q2a3": {
                    db: { quizId: 5, optionId: 18 }
                },
                "prod-q2a4": {
                    db: { quizId: 5, optionId: 19 }
                },
                "prod-q2a5": {
                    db: { quizId: 5, optionId: 20 }
                }
            },
            "prod-q3": {
                "prod-q3a1": {
                    db: { quizId: 6, optionId: 21 }
                },
                "prod-q3a2": {
                    db: { quizId: 6, optionId: 22 }
                },
                "prod-q3a3": {
                    db: { quizId: 6, optionId: 23 }
                },
                "prod-q3a4": {
                    db: { quizId: 6, optionId: 24 }
                },
                "prod-q3a5": {
                    db: { quizId: 6, optionId: 25 }
                },
                "prod-q3a6": {
                    db: { quizId: 6, optionId: 26 }
                },
                "prod-q3a7": {
                    db: { quizId: 6, optionId: 27 }
                },
                "prod-q3a8": {
                    db: { quizId: 6, optionId: 28 }
                }
            },
            "prod-q4": {
                "prod-q4a1": {
                    db: { quizId: 7, optionId: 29 }
                },
                "prod-q4a2": {
                    db: { quizId: 7, optionId: 30 }
                },
                "prod-q4a3": {
                    db: { quizId: 7, optionId: 31 }
                },
                "prod-q4a4": {
                    db: { quizId: 7, optionId: 32 }
                }
            },
            "prod-q5": {
                "prod-q5a1": {
                    db: { quizId: 8, optionId: 33 }
                },
                "prod-q5a2": {
                    db: { quizId: 8, optionId: 34 }
                },
                "prod-q5a3": {
                    db: { quizId: 8, optionId: 35 }
                },
                "prod-q5a4": {
                    db: { quizId: 8, optionId: 36 }
                },
                "prod-q5a5": {
                    db: { quizId: 8, optionId: 37 }
                },
                "prod-q5a6": {
                    db: { quizId: 8, optionId: 38 }
                }
            }
        };
        this.quizDataToDb = (questionId, answerId) => {
            const exists = (this.dualRecords[questionId] &&
                this.dualRecords[questionId][answerId]);
            if (!exists)
                return;
            return this.dualRecords[questionId][answerId].db;
        };
    }
}
// export Utils class instance (singleton)
export const __map = new Maps();
